import { AfterContentInit, Component, ContentChildren, EventEmitter, QueryList, Output } from '@angular/core';

import { PuiListItemComponent } from './list-item.component';

@Component({
  selector: 'pui-list',
  templateUrl: 'list.component.html'
})
export class PuiListComponent implements AfterContentInit {
  @ContentChildren(PuiListItemComponent) items: QueryList<PuiListItemComponent>;
  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngAfterContentInit() { }

  onClick(item: any): void {
    if (this.items) {
      this.items.forEach(i => i.active = false);
      item.active = true;

      this.select.emit(item);
    }
  }
}
